import { render, staticRenderFns } from "./group_members.vue?vue&type=template&id=1688eb16&scoped=true&"
import script from "./group_members.vue?vue&type=script&lang=ts&"
export * from "./group_members.vue?vue&type=script&lang=ts&"
import style0 from "./group_members.vue?vue&type=style&index=0&id=1688eb16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1688eb16",
  null
  
)

export default component.exports